module.exports = __webpack_public_path__ + "static/hordeBotHelp-4408ceb5cd16250c46151bfcaf80772c.png";